import { useEffect } from 'react';

export const useBWTag = (): void => {
  useEffect(() => {
    if (window.isHeadless) {
      return;
    }

    window.bwtag('set', 'appId', import.meta.env.VITE_BRIGHTWRITE_APP_ID);
    window.bwtag(
      'set',
      'appVersion',
      import.meta.env.VITE_BRIGHTWRITE_APP_VERSION,
    );
    window.bwtag(
      'set',
      'publicKey',
      import.meta.env.VITE_BRIGHTWRITE_PUBLIC_KEY,
    );
    window.bwtag('set', 'autoPvTracking', true);
  }, []);
};
